import React from 'react'
import { Spin } from 'antd';

export default function Loading({ height = '100vh' }) {
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: height,
            borderRadius: 4,
        }}>
            <Spin size="large" />
        </div>
    )
}

export function LoadingMini() {
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px 0',
        }}>
            <Spin size="default" />
        </div>
    )
}
